import { FlagState } from '../libs';

export const FLAG_SUP_FEATURES: FlagState = {
  WEBAPP_RETURN_REQUEST: true,
  epic_ecom_269: false,
  epic_pb_613: false,
  epic_omni_389: false,
  MML_NO_PAYMENT: false,
  epic_omni_677: false,
  epic_omni_964: true,
  epic_ecom_284: false,
  epic_ecom_460: false,
  omni_848_consumer: true,
  epic_ecom_315: false,
  epic_omni_1058: false,
  epic_omni_1237: false,
  epic_ecom_472: true,
  epic_ecom_479: false,
  epic_ecom_483: false,
};
